import React from 'react';
import ReactDOM from 'react-dom';
import SideNav from './components/sidenav/sidenav.js';
import registerServiceWorker from './registerServiceWorker';
import './index.css';

ReactDOM.render(<SideNav
mathItems={["sqrd","pwr","toNotationStr","toNotation","fromNotation","cm2ft","ft2cm","gall2litre","litre2gall","radians",
"degrees","PI","clamp","isPwrTwo","decimalToBin","txtToAsc","ascToTxt","logBase","E","toFahrenheit","toKelvin","random","seed", "parity","aprox", "isEmpty", "exists"]}
arrItems={["parityArray","median","range","avg","toJSON","add","multiply","expand","arrClampValue","arrLock","toObject",
"flatten","break","isVacant","isolate","tally","flip","randomArr","insert","init","app", "cloneArr"]}
objItems={["k","v","holdsKey","holdsVal","grabVal","grabKey","lose"]}
objMath = {{
	sqrd:{
		name:"sqrd(int)",
		code:`Mathf.sqrd(8) // 64\nMathf.sqrd(2) // 4\nMathf.sqrd(100) // 10000`,
		desc:`Squares the parameter.`
	},
	pwr:{
		name:"pwr(int, power)",
		code:`Mathf.pwr(2, 9) // 512\nMathf.pwr(7, 2) // 49\nMathf.pwr(13, 8) // 815730721`,
		desc:`First parameter to the power of the second.`
	},
	toNotationStr:{
		name:"toNotationStr(largeInt)",
		code:`Mathf.toNotationStr("71312321") // 7.1312321 * 10(7)\nMathf.toNotationStr("0000973621") // 9.73621 * 10(-4)\nMathf.toNotationStr("888888") // 8.88888 * 10(5)\n\n/* Known Issues */\nMathf.toNotationStr("10000") // will return incorrect value.\nMathf.toNotationStr("100001") // will also return incorrect value.`,
		desc:`/************** [STILL UNDER DEVELOPMENT] **************/ Will turn your given parameter into a scientific notation but will be in the form of a string. Note: The number between the parentheses is the power of the number beside it, for example 10(7) would be 10 to the power of 7.\nYour parameter must be surrounded with quotes for this to work properly.`
	},
	toNotation:{
		name:"toNotation(largeInt)",
		code:`Mathf.toNotation("0000973621") // 9.73621\nMathf.toNotation("34324343223545645") // 3.4324343223545646\nMathf.toNotation("888888") // 8.88888`,
		desc:`This will only return the float of the parameter in scientific notation form, without including the tenth power required to revert it back to its original self. Again, your parameter must be surrounded with quotes for this to work properly.`
	},
	fromNotation:{
		name:"Coming soon",
		code:`-`,
		desc:`Currently fixing bugs.`
	},
	cm2ft:{
		name:"cm2ft(cm, ft)",
		code:`Mathf.cm2ft(10) // 0.32808400000000004\nMathf.cm2ft(30.48) // 1.000000032\nMathf.cm2ft(999) // 32.7755916`,
		desc:`Converts parameter (cm) into (ft).`
	},
	ft2cm:{
		name:"cm2ft(ft, cm)",
		code:`Mathf.ft2cm(10) // 304.8\nMathf.ft2cm(30.48) // 929.0304\nMathf.ft2cm(999) // 30449.52`,
		desc:`Converts parameter (ft) into (cm).`
	},
	gall2litre:{
		name:"gall2litre(gallon)",
		code:`Mathf.gall2litre(10) // 37.8541\nMathf.gall2litre(30.48) // 115.3792968\nMathf.gall2litre(999) // 3781.6245900000004`,
		desc:`Converts parameter (gallon) into (litre).`
	},
	litre2gall:{
		name:"litre2gall(litre)",
		code:`Mathf.litre2gall(10) // 2.6417200000000003\nMathf.litre2gall(30.48) // 8.051962560000002\nMathf.litre2gall(999) // 263.907828`,
		desc:`Converts parameter (litre) into (gallon).`
	},
	radians:{
		name:"radians(degree)",
		code:`Mathf.radians(10) // 0.17453300000000002\nMathf.radians(30.48) // 0.531976584\nMathf.radians(90) // 1.5707970000000002`,
		desc:`Converts parameter (degree) into (radian).`
	},
	degrees:{
		name:"radians(radian)",
		code:`Mathf.degree(10) // 572.958\nMathf.degree(30.48) // 1746.375984\nMathf.degree(90) // 5156.6222`,
		desc:`Converts parameter (radian) into (degree).`
	},
	PI:{
		name:"PI",
		code:`Mathf.PI // 3.14159265359`,
		desc:`Value of PI.`
	},
	clamp:{
		name:"clamp(int, min, max)",
		code:`Mathf.clamp(8, 1, 5) // 5\nMathf.clamp(3, 1, 5) // 3\nMathf.clamp(-10, 1, 5) // 1`,
		desc:`Clamps a given parameter between a minimum and maximum int.`
	},
	isPwrTwo:{
		name:"isPwrTwo(int)",
		code:`Mathf.isPwrTwo(2) // true\nMathf.isPwrTwo(16) // true\nMathf.isPwrTwo(1) // false`,
		desc:`Checks if a parameter is a power of two, if it is, it will return true.`
	},
	decimalToBin:{
		name:"decimalToBin(int)",
		code:`Mathf.decimalToBin(99) // 1100011\nMathf.decimalToBin(4543) // 1000110111111\nMathf.decimalToBin(19) // 10011`,
		desc:`Converts decimal to binary.`
	},
	txtToAsc:{
		name:"txtToAsc(text)",
		code:`Mathf.txtToAsc("Hello") // [72,101,108,108,111]\nMathf.txtToAsc("Mathf is the best") // [77,97,116,104,102,32,105,115,32,116,104,101,32,98,101,115,116]\nMathf.txtToAsc("dutyasvdtagwb") // [100,117,116,121,97,115,118,100,116,97,103,119,98]`,
		desc:`Converts text to ascii. This will only convert letters, using numbers or symbols will not work.`
	},
	ascToTxt:{
		name:"txtToAsc(text)",
		code:`Mathf.ascToTxt([72,101,108,108,111]) // Hello\nMathf.ascToTxt([77,97,116,104,102,32,105,115,32,116,104,101,32,98,101,115,116]) // Mathf is the best\nMathf.ascToTxt([100,117,116,121,97,115,118,100,116,97,103,119,98]) // dutyasvdtagwb`,
		desc:`Converts ascii to text.`
	},
	logBase:{
		name:"txtToAsc(base, log)",
		code:`Mathf.logBase(10, 1000) // 2.9999999999999996 (Note: Would be 3 if js Logarithms were perfect)\nMathf.logBase(8, 3) //  0.5283208335737187\nMathf.logBase(9, 4) //  0.6309297535714574`,
		desc:`Get base (parameter) logarithm of (parameter). Logarithms in javascript arent always perfectly accurate but are only usually slightly off.`
	},
	E:{
		name:"E",
		code:`Mathf.E // 2.7182818284590452353602875`,
		desc:`The value of E.`
	},
	toFahrenheit:{
		name:"toFahrenheit(celsius)",
		code:`Mathf.toFahrenheit(100) // 212\nMathf.toFahrenheit(70) // 158\nMathf.toFahrenheit(30) // 86`,
		desc:`Converts Celsius to Fahrenheit.`
	},
	toKelvin:{
		name:"toKelvin(celsius)",
		code:`Mathf.toKelvin(100) // 373\nMathf.toKelvin(70) // 343\nMathf.toKelvin(30) // 303`,
		desc:`Converts Celsius to Kelvin.`
	},
	random:{
		name:"random(from, to)",
		code:`Mathf.random(1, 20) // 3\nMathf.random(1, 20) // 10\nMathf.random(10, 40) // 33`,
		desc:`Chooses a random number between parameter one and parameter two.`
	},
	seed:{
		name:"seed(length)",
		code:`Mathf.seed(2) // 74\nMathf.seed(10) // 4828821837\nMathf.seed(30) // 818258243146673822531264199559`,
		desc:`Generates random seed of numbers with length set to given parameter.`
	},
	parity:{
		name:"parity(int)",
		code:`Mathf.parity(2) // true\nMathf.parity(7) // false\nMathf.parity(14) // true`,
		desc:`Returns true if a number is even and false if it isn't.`
	},
	aprox:{
		name:"aprox(int)",
		code:`Mathf.aprox(1.9,1.2) // true\nMathf.aprox(2.9,1.2) // false\nMathf.aprox(2.111111,2.999999) // true`,
		desc:`Compares two numerical values to see if they are similar.`
	},
	exists:{
		name:"exists(item)",
		code:`var x = "defined"\n\nMathf.exists(x) // true\nMathf.exists(AnUndefinedVariable) // false\n\nlet m = null;\nMathf.exists(m) // false`,
		desc:`Returns false if the given paramater is equal to null or is undefined.`
	},
	isEmpty:{
		name:"isEmpty(item)",
		code:`Mathf.isEmpty("") // true\nMathf.isEmpty("---") // false\n Mathf.isEmpty([]) // true`,
		desc:`Returns true if the given item is empty.`
	},
}}
objObject = {{
	holdsKey:{
		name:"holdsKey(obj, searchKey)",
		code:"Mathf.holdsKey({One:1, Two:2}, 'One') // true\nMathf.holdsKey({One:1, Two:2}, 'Three') // false\nMathf.holdsKey({One:1, Two:2}, '2') // false",
		desc:"This will return true if the given key exists within an object."
	},
	k:{
		name:"k (obj)",
		code:"Mathf.v({One:'O-N-E', Two:'T-W-O'}) // ['One', 'Two']\nMathf.v({One:1, Two:2, Three:3, Four:4}) // ['One','Two','Three','Four']\nMathf.v({A: (sayhi) => {alert(sayhi)}, One:'Two', Three:3}) // ['A','One','Three']",
		desc:"This will return all keys from an object and stores them inside an array."
	},
	v:{
		name:"v (obj)",
		code:`Mathf.v({One:"O-N-E", Two:"T-W-O"}) // ["O-N-E", "T-W-O"]\nMathf.v({One:1, Two:2, Three:3, Four:4}) // [1,2,3,4]\nMathf.v({A: (sayhi) => {alert(sayhi)}, One:"Two", Three:3}) // ["(sayhi) => {alert(sayhi)}","Two",3]`,
		desc:"This will return all values from an object and stores them inside an array."
	},
	holdsVal:{
		name:"holdsVal(obj)",
		code:`Mathf.holdsVal({One:1, Two:2}, 1) // true\nMathf.holdsVal({One:1, Two:2}, "Two") // false\nMathf.holdsVal({One:1, Two:2}, 2) // true`,
		desc:"This will return true if the given value exists within an object."
	},
	grabVal:{
		name:"grabVal (obj, key)",
		code:`Mathf.grabVal({One:1, Two:2, Three:3}, "One") // 1\nMathf.grabVal({One:1, Two:2, Three:3}, "Two") // 2\nMathf.grabVal({One:1, Two:2, Three:3}, "Three") // 3`,
		desc:"This will return the value of the given key."
	},
	grabKey:{
		name:"grabKey (obj, val)",
		code:"Mathf.grabKey({One:1, Two:2, Three:3}, 1) // One\nMathf.grabKey({One:1, Two:2, Three:3}, 2) // Two\nMathf.grabKey({One:1, Two:2, Three:3}, 3) // Three",
		desc:"This will return the key of a given value."
	},
	lose:{
		name:"lose(obj, keys...)",
		code:`/* We will create an object template to demonstrate use. */ \n function Employee(name, age, department) { \n this.name = name, \n this.age = age, \n this.department = department \n }; \n\n\n /* We will create default object... */\n const original = new Employee("John",21,"Software Engineer");\n const x = new Employee("John",21,"Software Engineer");\n \n /* and our object with our key/s removed.. */\n const flitered = Mathf.lose(x, "age", "name"); \n\n\n return original.age + " | " + original.name + " | " + original.department \n // 21 | John | Software Engineer\n\n return flitered.age + " | " flitered.name + " | " + flitered.department \n // undefined | undefined | Software Engineer`,
		desc:"This will remove the given key/s from an object. Lose will change the object it is called on, not return a new modified version of it."
	},
}}
objArr = {{
	parityArray:{
		name:"parityArray(arr)",
		code:`Mathf.parityArray([1,2,3]) // false\nMathf.parityArray(["a","b"]) // true\nMathf.parityArray([1,2,3,4,5,6,7,8]) // true`,
		desc:"Returns true if the amount of items in an array is an equal number."
	},
	median:{
		name:"median(arr)",
		code:`Mathf.median([1,2,3,4,5]) // 3\nMathf.median([1,2,3,4,5,6]) // 3.5\nMathf.median([1,2,3]) // 2`,
		desc:"Calculates the median of a numerical array."
	},
	range:{
		name:"range(arr)",
		code:`Mathf.range([3,5,9,8,4]) // 5\nMathf.range([80,1,6,9,45,2,3]) // 79\nMathf.range([-80,3000,2,3,8,8343]) // 8423`,
		desc:"Calculates the range of a numerical array."
	},
	avg:{
		name:"avg(arr)",
		code:`Mathf.avg([3,5,9,8,4]) // 5.8\nMathf.avg([100,-99,-3,2,4,8]) // 2\nMathf.avg([1,3,7,9,2,88]) // 18.333333333333332`,
		desc:"Calculates the arithmetic mean/average of a numerical array."
	},
	toJSON:{
		name:"toJSON(arr)",
		code:`Mathf.toJSON({one: "two"}) // {"one":"two"}\nMathf.toJSON(['hello', 'hi']) // ["hello","hi"]\nMathf.toJSON(['1','2','3']) // ["1","2","3"]`,
		desc:"Converts array or object to JSON standards."
	},
	add:{
		name:"add(arr)",
		code:`Mathf.add([1,2,3]) // 6\nMathf.add([3,3,3]) // 9\nMathf.add([8,8,8,8]) // 32`,
		desc:"Adds all numerical values in an array together."
	},
	multiply:{
		name:"multiply(arr)",
		code:`Mathf.multiply([3,3,3]) // 27\nMathf.multiply([7,7]) // 49\nMathf.multiply([1,2,3,54,9]) // 2916`,
		desc:"Multiplies all numerical values in an array by each other."
	},
	expand:{
		name:"expand(arr)",
		code:`Mathf.expand(10) // [1,1,1,1,1,1,1,1,1,1]\nMathf.expand(5) // [1,1,1,1,1]\nMathf.expand(3) // [1,1,1]`,
		desc:"Converts given integer into an array of 1's."
	},
	arrClampValue:{
		name:"arrClampValue(arr, min, max)",
		code:`Mathf.arrClampValue([1,2,3,4,5,6,7,8],3,6) // [3,3,3,4,5,6,6,6]\nMathf.arrClampValue([2,999,1001,1000,-30],0,999) // [2,999,999,999,0]\nMathf.arrClampValue([1,2,3,4,5],1,5) // [1,2,3,4,5]`,
		desc:"Clamps the values of each numerical value in an array between (min) and (max)."
	},
	arrLock:{
		name:"arrLock(arr, max)",
		code:`Mathf.arrLock([1,2,3,4,5,6,7,8],3) // [1,2,3]\nMathf.arrLock([99,88,342,-234,99,1,2,3,4,5], 4) // [99,88,342,-234]\nMathf.arrLock([9387432,78324893274,2398473298,234823732], 0) // []`,
		desc:"Returns all array items within the maximum limit given."
	},
	toObject:{
		name:"toObject(arr)",
		code:`const newObj = Mathf.toObject(["Key0","Val0","Key1","Val1","Key2","Val2"]);\nreturn newObj.Key0 // { Val0 }\n\n\nconst newObj = Mathf.toObject(["Hello","Bye"]);\nreturn newObj.Hello // { Bye }\n\n\nconst newObj = Mathf.toObject(["Key0"]) // null`,
		desc:"Converts every two array items into an objects key and value. If the array is not equal there will not be a value for one of the keys so it will return null."
	},
	flatten:{
		name:"flatten(arr)",
		code:`Mathf.flatten([[1,2,3,4],["one","two",3]]) // [1,2,3,4,"one","two",3]\nMathf.flatten([["hello"],[38127649]]) // ["hello",38127649]\nMathf.flatten([[10,11],[12,13],[19,20]]) // [10,11,12,13,19,20]`,
		desc:"This will conjoin mulitple arrays within an array."
	},
	break:{
		name:"break(arr, int)",
		code:`Mathf.break([1,2,3,4,5,6,7], 2) // [ [1,2], [3,4], [5,6], [7] ] \nMathf.break([1,2,3,4,5,6,7], 7) // [ [1,2,3,4,5,6,7] ] \nMathf.break([1,2,3,4,5,6,-20], 4) // [ [1,2,3,4], [5,6,-20] ]`,
		desc:"This will break an array into smaller arrays with the capacity of parameter."
	},
	isVacant:{
		name:"isVacant(arr)",
		code:`Mathf.isVacant([]) // true\nMathf.isVacant([1]) // false\nMathf.isVacant([{}] // false`,
		desc:"This will return true if the array is empty."
	},
	isOccupied:{
		name:"isOccupied(arr)",
		code:`Mathf.isOccupied([]) // false\nMathf.isOccupied([1]) // true\nMathf.isOccupied([{}] // true`,
		desc:"This will return true if the array is not empty."
	},
	isolate:{
		name:"isolate(arr)",
		code:`Mathf.isolate([1,1,1,1,1,2,3,4,55,5,5,5,5,5,5,5]) // [1,2,3,4,55,5]\nMathf.isolate(["a", "a", "b", "b"]) // [a,b]\nMathf.isolate(["a",1,"b",1,"c",1]) ["a",1,"b","c"]`,
		desc:"This will remove any duplicates from an array."
	},
	tally:{
		name:"tally(arr)",
		code:`Mathf.tally([1,2,3,4]) // 4\nMathf.tally(["one","two","three"]) // 3\nMathf.tally([1,2,3,43,4,4,5,6554354353]) // 8`,
		desc:"This will return the amount of items within an array."
	},
	flip:{
		name:"flip(arr)",
		code:`Mathf.flip([1,2,3,4,5,6]) // [6,5,4,3,2,1]\nMathf.flip(["one","two","three"]) // ["three", "two", "one"]\nMathf.flip([1,1,1,2,3,44,44,44]) // [44,44,44,3,2,1,1,1]`,
		desc:"This will reverse/flip an array and return it."
	},
	randomArr:{
		name:"randomArr(arr)",
		code:`Mathf.randomArr([1,2,3,4,5,6]) // [1]\nMathf.randomArr([1,2,3,4,5,6]) // [5]\nMathf.randomArr(["one", "two", "three"]) // ["one"]`,
		desc:"This will pick a random array element and return it."
	},
	insert:{
		name:"insert(arr, pos, item)",
		code:`Mathf.insert([1,2,3,4,5], 3) // [1,2,3,"will be placed after given pos",4,5]\nMathf.insert([1,2,3,4,5], 10) // [1,2,3,4,5,10]\nMathf.insert(["one", "two"], 0, "zero") // ["zero", "one", "two"]`,
		desc:"This will insert a new item into an array with its position as (parameter)."
	},
	init:{
		name:"init(arr)",
		code:`Mathf.init([1,2,3,4,5]) // [1]\nMathf.init([5,4,3,2,1]) // [5]\nMathf.init(["one", "two"]) // ["one"]`,
		desc:"This returns the inital item in an array."
	},
	app:{
		name:"app(arr, item)",
		code:`Mathf.app([1,2,3,4,5], 6) // [1,2,3,4,5,6]\nMathf.app(["one", "two"], "three") // ["one","two","three"]\nMathf.app([1,"a","b",2], "h e l l o") // [1,"a","b",2,"h e l l o"]`,
		desc:"This will append a given item to the end of an array."
	},
	cloneArr:{
		name:"cloneArr(arr)",
		code:`let r = [1,2,3] const x = Mathf.cloneArr(r) // r and x are now two seperate arrays that can be altered/filtered seperatly`,
		desc:"Will clone the given arr as a new var."
	},

}}/>, document.getElementById('nav'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js